const sectionIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1098 5.63415H5.89024C5.74881 5.63415 5.63415 5.74881 5.63415 5.89024V7.93902C5.63415 8.08046 5.74881 8.19512 5.89024 8.19512H15.1098C15.2512 8.19512 15.3659 8.08046 15.3659 7.93902V5.89024C15.3659 5.7488 15.2512 5.63415 15.1098 5.63415ZM5.89024 4.09756C4.90017 4.09756 4.09756 4.90017 4.09756 5.89024V7.93902C4.09756 8.9291 4.90017 9.73171 5.89024 9.73171H15.1098C16.0998 9.73171 16.9024 8.9291 16.9024 7.93902V5.89024C16.9024 4.90017 16.0998 4.09756 15.1098 4.09756H5.89024Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1098 12.8049H5.89024C5.74881 12.8049 5.63415 12.9195 5.63415 13.061V15.1098C5.63415 15.2512 5.74881 15.3659 5.89024 15.3659H15.1098C15.2512 15.3659 15.3659 15.2512 15.3659 15.1098V13.061C15.3659 12.9195 15.2512 12.8049 15.1098 12.8049ZM5.89024 11.2683C4.90017 11.2683 4.09756 12.0709 4.09756 13.061V15.1098C4.09756 16.0998 4.90017 16.9024 5.89024 16.9024H15.1098C16.0998 16.9024 16.9024 16.0998 16.9024 15.1098V13.061C16.9024 12.0709 16.0998 11.2683 15.1098 11.2683H5.89024Z"
      fill="#6B00DF"
    />
  </svg>
);

export default sectionIcon;
